import React from 'react'
import PropTypes from 'prop-types'
import { ProductPageTemplate } from '../../templates/product-page';
import { CartContextProvider } from '../../contexts/CartContext';
import ProductsContextProvider from '../../contexts/ProductsContext';

const ProductPagePreview = ({ entry, getAsset, widgetFor }) => {
  // console.dir(widgetFor('body'));
  return (
    <ProductsContextProvider><CartContextProvider>
    <ProductPageTemplate
      image={getAsset(entry.getIn(['data', 'image']))}
      title={entry.getIn(['data', 'title'])}
      heading={entry.getIn(['data', 'heading'])}
      // html={entry.getIn(['data', 'html'])}
      content={widgetFor('body')}
      slug={entry.getIn(['data', 'slug'])}
      price={entry.getIn(['data', 'price'])}
      weight={entry.getIn(['data', 'weight'])}
      sku={entry.getIn(['data', 'sku'])}
      variants={entry.getIn(['data', 'variants']).toJS()}
    />
    </CartContextProvider></ProductsContextProvider>
  )
}

ProductPagePreview.propTypes = {
  entry: PropTypes.shape({
    getIn: PropTypes.func,
  }),
  fieldsMetaData: PropTypes.func,
  getAsset: PropTypes.func,
  widgetFor: PropTypes.func,
}

export default ProductPagePreview
